import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { AppProvider } from "@/contexts/AppContext";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CaseOverview from "@/pages/CaseOverview";
import Procedure from "@/pages/Procedure";
import Timeline from "@/pages/Timeline";
import Witnesses from "@/pages/Witnesses";
import Evidence from "@/pages/Evidence";
import DigitalEvidence from "@/pages/DigitalEvidence";
import Forensics from "@/pages/Forensics";
import CaseLaw from "@/pages/CaseLaw";
import DefenseTheory from "@/pages/DefenseTheory";
import Hearings from "@/pages/Hearings";
import Tasks from "@/pages/Tasks";
import AIPrompts from "@/pages/AIPrompts";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Onboarding from "@/pages/Onboarding";
import Billing from "@/pages/Billing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import AuditLog from "@/pages/AuditLog";
import Courtroom from "@/pages/Courtroom";

function GuardedRoutes() {
  const { user } = useAuth();
  if (user === null) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-muted-foreground font-mono text-sm animate-pulse-soft">loading…</div>
    </div>
  );
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace/> : <Login/>} />
      <Route path="/register" element={user ? <Navigate to="/" replace/> : <Register/>} />
      <Route path="/forgot-password" element={<ForgotPassword/>} />
      <Route path="/reset-password" element={<ResetPassword/>} />
      <Route path="/onboarding" element={user ? <Onboarding/> : <Navigate to="/login" replace/>} />
      <Route path="/billing/success" element={user ? <PaymentSuccess/> : <Navigate to="/login" replace/>} />
      <Route path="/courtroom" element={user ? <Courtroom/> : <Navigate to="/login" replace/>} />
      <Route path="/" element={<AppShell/>}>
        <Route index element={<Dashboard/>} />
        <Route path="case" element={<CaseOverview/>} />
        <Route path="procedure" element={<Procedure/>} />
        <Route path="timeline" element={<Timeline/>} />
        <Route path="witnesses" element={<Witnesses/>} />
        <Route path="evidence" element={<Evidence/>} />
        <Route path="digital-evidence" element={<DigitalEvidence/>} />
        <Route path="forensics" element={<Forensics/>} />
        <Route path="case-law" element={<CaseLaw/>} />
        <Route path="defense-theory" element={<DefenseTheory/>} />
        <Route path="hearings" element={<Hearings/>} />
        <Route path="tasks" element={<Tasks/>} />
        <Route path="ai-prompts" element={<AIPrompts/>} />
        <Route path="reports" element={<Reports/>} />
        <Route path="billing" element={<Billing/>} />
        <Route path="audit-log" element={<AuditLog/>} />
        <Route path="settings" element={<Settings/>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace/>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <GuardedRoutes/>
          <Toaster theme="dark" position="bottom-right" toastOptions={{
            classNames: { toast: "bg-card border border-border/80" }
          }}/>
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
